import { render, staticRenderFns } from "./AddToWishlist-v2.vue?vue&type=template&id=b4230b7e&scoped=true&"
import script from "./AddToWishlist-v2.vue?vue&type=script&lang=js&"
export * from "./AddToWishlist-v2.vue?vue&type=script&lang=js&"
import style0 from "./AddToWishlist-v2.vue?vue&type=style&index=0&id=b4230b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4230b7e",
  null
  
)

export default component.exports